export default __webpack_public_path__ + "static/media/logo.dbdd5367.svg";